import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type ActiveStorageAttachment from "./ActiveStorageAttachment";

@Model()
class ActiveStorageBlob extends ApplicationRecord {
  static jsonapiType = "active_storage_blobs";

  @BelongsTo() activeStorageAttachment: ActiveStorageAttachment;

  @Attr() byteSize: number;

  @Attr() checksum: string;

  @Attr() contentType: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() filename: string;

  @Attr({ persist: false }) image: boolean;

  @Attr() key: string;

  @Attr() metadata: Record<string, any>;

  @Attr({ persist: false }) relativeUrl: string;

  @Attr({ persist: false }) video: boolean;
}

export default ActiveStorageBlob;
